import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import { NotificationManager } from 'react-notifications'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus'


export const logoutAction = () => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.LOGOUT
  const logoutOptions = {
    method: HTTP_METHOD.POST,
    headers: getHeaders(),
    url: url
  }
  return axiosInstance(logoutOptions).then(response => {
    if (response?.status === HTTP_STATUS.SUCCESS) {
      return response
    } else {
      return null
    }
  }).catch(error => {
    if (error?.response?.status === HTTP_STATUS.UNAUTHORIZED) {
      NotificationManager.error(error.response.data.message)
    }
    return error
  })
}